if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.featured-items__slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    variableWidth: true,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    variableWidth: true,
                    arrows: false
                }
            }
        ]
    });

    $('.accommodations__filter .rooms-nav .js-getRooms').click(function(){
        $('.accommodations__slider-images').slick('unslick');
        const thisTag = $(this).attr('data-tag');
        if(thisTag == 'all'){
            $('.accommodations__room').hide();
            $('.accommodations__room').fadeIn();
            $('.accommodations__room .accommodations__slider-images').slick({
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                fade: true,
                infinite: false,
                accessibility: true
            });
            $('.accommodations__filter .rooms-nav .js-getRooms').removeClass('active');
            $('.accommodations__filter .rooms-nav .js-getRooms').attr('aria-selected','false');
            $(this).addClass('active');
            $(this).attr('aria-selected','true');
        }else{
            $('.accommodations__room').hide();
            $('.accommodations__room.'+thisTag).fadeIn();
            $('.accommodations__room.'+thisTag+' .accommodations__slider-images').slick({
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 500,
                fade: true,
                infinite: false,
                accessibility: true
            });

            $('.accommodations__filter .rooms-nav .js-getRooms').removeClass('active');
            $('.accommodations__filter .rooms-nav .js-getRooms').attr('aria-selected','false');
            $(this).addClass('active');
            $(this).attr('aria-selected','true');
        }
    })

    if(document.querySelector('.accommodations__filter')){
        const filter_tab = document.querySelectorAll('.accommodations__filter .rooms-nav .js-getRooms'); filter_tab[filter_tab.length - 1].click();
    }

    if($('.location-points').length > 0){
        const points_map = document.querySelectorAll('.location-points__item');
        const images_map = document.querySelectorAll('.image-point');
        $('.location-points__map--pin').click(function(){
            for(let z = 0; z<images_map.length; z++){
                images_map[z].getElementsByTagName('img')[0].src = images_map[z].dataset.img;
            }
            for(let z = 0; z<points_map.length; z++){
                if(this.dataset.ref == points_map[z].dataset.ref){
                    points_map[z].classList.add('active');
                    $(this).find('img').attr('src', this.dataset.hover);
                }else{
                    points_map[z].classList.remove('active');
                }
            }
            $('.location-points__map--pin').removeClass('active');
            $(this).addClass('active');
        })

    }

    $('.form-module').addClass('animate-fade');
    $('.text-modules').addClass('animate-fade top');

    $('.datepicker').attr('placeholder','MM/DD/YYYY');

    $('.slick-arrow').addClass('animate-fade top');

    const acc_btns = document.querySelectorAll('.accordion__button');
    const acc_items = document.querySelectorAll('.accordion__item');
    if(acc_btns){
        for(let i = 0; i < acc_btns.length; i++){
            acc_btns[i].addEventListener('click', function(){
                if(this.closest('.accordion__item').classList.contains('active')){
                    this.closest('.accordion__item').classList.remove('active');
                }else{
                    for(let a = 0; a < acc_items.length; a++){
                        acc_items[a].classList.remove('active');
                    }
                    this.closest('.accordion__item').classList.add('active');
                }
            })
        } 
    }

    if(document.querySelector('.js-open-menu-mobile')){
        const openMenu = document.querySelector('.js-open-menu-mobile');
        const closeMenu = document.querySelector('.close-menu');
        openMenu.addEventListener('click', function(){
            document.querySelector('.navigation').classList.add('show');
        });
        closeMenu.addEventListener('click', function(){
            document.querySelector('.navigation').classList.remove('show');
        })
    }

    $('[data-fancybox]').fancybox({
        toolbar  : false,
        smallBtn : true
    })
    
    setTimeout(function(){
        $('.galleryhover_overlay').append('<div class="icon"><span></span></div>');
    }, 500);

    $('.scroll-link').click(function () {
        var target = $(this).attr("href");
        $('html, body').animate({scrollTop: $(target).offset().top - 120}, 1000);
        return false;
    });


})();